module.exports = __webpack_public_path__ + "img/monster.2bde362f.png";